export default {
  label: {
    mentionsText: 'Menções',
  },
};
